/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import { getToken } from '../AuthService';
import React, { useRef, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import * as default_data from '../config.js'
import { Box, Paper, useTheme } from '@mui/material';

const AskSagePlaylist = () => {
  const [videos, setVideos] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const videoPlayerRef = useRef(null);
  var loaded_static = false;
  const theme = useTheme();

  useEffect(() => {
    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    const fetchVideos = async () => {
      var token = getToken()
      if(token === false) {
        return;
      }
  
      fetch(default_data.default_chat_service_url + '/get-learning-videos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if(data.status != 200) {
              return;
          }
          data = data.response;
          setVideos(data.items);
          setCurrentVideo(data.items[0]);
        })
        .catch(error => {
          console.log(error);
        });
  
    };
    fetchVideos();
  }, []);

  const handleVideoClick = (video) => {
    setCurrentVideo(video);
    videoPlayerRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box>
      { videos && videos.length != 0 &&
        <div className="video-container">
          <div className="video-list">
            {videos.map((video) => (
              <Paper
                key={video.id}
                className={`video-item ${
                  currentVideo?.id === video.id ? 'active' : ''
                }`}
                onClick={() => handleVideoClick(video)}
                sx={{
                  backgroundColor: theme.palette.card.backgroundColor,
                  border: theme.palette.card.border,
                  cursor: 'pointer',
                  '&:hover': theme.palette.card.hover,
                }}
              >
                {video.snippet.thumbnails !== undefined && video.snippet.thumbnails !== null && video.snippet.thumbnails.medium !== undefined && video.snippet.thumbnails.medium !== null ? 
                <img
                  src={video.snippet.thumbnails.medium.url}
                  alt={video.snippet.title}
                />: ''}
                <div className="video-info">
                  <h3>{video.snippet.title}</h3>
                </div>
              </Paper>
            ))}
          </div>
          <div className="video-player" ref={videoPlayerRef}>
            {currentVideo && (
              <ReactPlayer
                url={`https://www.youtube.com/watch?v=${currentVideo.snippet.resourceId.videoId}`}
                width="100%"
                height="100%"
                controls
                config={{ youtube: { playerVars: { showinfo: 1 } } }}
              />
            )}
          </div>
        </div>
      }
    </Box>
  );
};

export default AskSagePlaylist;
